import React, { useImperativeHandle, useRef, useState } from "react";
import { RCCGrid, RCCRefModalProps, RCCInput, RCCHookToast, RCCServicesApi } from "react-common-components";
import { useForm } from "react-hook-form";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import Modal from "../Modal";
import Title from "../Title";
import IRefModalAccessKey from "./interface";

const ModalAccessKey: React.ForwardRefRenderFunction<IRefModalAccessKey> = (_, ref) => {
	const { translate } = useTranslation();
	const { addToast } = RCCHookToast();
	const { handleSubmit, register, reset } = useForm();

	const modalAccessKeyRef = useRef<RCCRefModalProps>(null);

	const [subtitle, setSubtitle] = useState("");
	const [onlyShowKey, setOnlyShowKey] = useState(false);
	const [keyDefaultValue, setKeyDefaultValue] = useState("");

	const onCallbackFunction = useRef<Function>(() => {});
	const companyId = useRef(0);
	

	const openModalAccessKey = (id: number, companyName: string, onCallback: Function) => {
		setOnlyShowKey(false);
		setKeyDefaultValue("");
		reset();
		setSubtitle(companyName);
		companyId.current = id;
		onCallbackFunction.current = onCallback;
		modalAccessKeyRef.current?.openModal();
	};

	const openModalOnlyShowAccessKey = (key: string) => {
		reset();
		setOnlyShowKey(true);
		setKeyDefaultValue(key);
		modalAccessKeyRef.current?.openModal();
	};

	const onSubmit = async (data: any) => {
		if(data.key.trim().length !== 6){
			addToast({
				color: "yellow",
				description: translate("Informe o valor da chave de acesso para prosseguir"),
				title: translate("Atenção")
			});
			return;
		}
		try{
			await RCCServicesApi.postRequest({
				method: "AccessKey/Validate",
				urlParameters: {
					key: data.key,
					efa002Id: companyId.current
				}
			});
			modalAccessKeyRef.current?.closeModal();
			onCallbackFunction.current();
		}catch(err){
			standardErrorMessages(err, translate("Chave de acesso externo inválida"), addToast);
		}
	};

	useImperativeHandle(ref, () => ({
		openModalAccessKey,
		openModalOnlyShowAccessKey
	}));

	return (
		<Modal
			ref={modalAccessKeyRef}
			header={{
				title: translate("Chave de acesso externo"),
				subtitle,
				icon: {
					name:  "key"
				}
			}}
			onSubmit={handleSubmit(onSubmit)}
			footer={{
				buttonLoadingText: translate("Carregando"),
				saveButtonText: translate("Ir"),
				cancelButtonText: onlyShowKey ? translate("Fechar") : translate("Cancelar"),
				showSaveButton: !onlyShowKey
			}}
			styleInline={`
				width: 60vw;
				min-width: 300px;
				max-width: 800px;
				height: 400px;
				position: absolute;
				top: 60px;
			`}
		>
			<RCCGrid container item justifyContent="center" alignItems="center" style={{ height: "100%" }}>
				<RCCGrid
					container
					item
					xs={12}
					sm={8}
					direction="column"
				>
					{!onlyShowKey && (
						<Title color="purple">
							{translate("Inserir chave de acesso externo")}
						</Title>
					)}
				
					<RCCInput 
						register={register}
						label=""
						name="key"
						maxLength={6}
						styleInline={`
							height: 100px !important;
							input{
								height: 100px !important;
								font-size: 75px !important;
								text-align: center;
							}
						`}
						defaultValue={keyDefaultValue}
						disabled={onlyShowKey}
					/>

					{onlyShowKey && (
						<Title size="sm" color="grey" styleInline="text-align: center;">
							{translate("A chave é valida para acesso somente pelas próximas duas horas ou até você finalizá-la pela opção Finalizar Sessão")}.
						</Title>
					)}

				</RCCGrid>
			</RCCGrid>
		</Modal>
	);
};

export default React.forwardRef(ModalAccessKey);

